<template>
  <div class="submit-container-wrap">
    <div
      class="submit-shadow"
      :class="{ isLogin: isLogin }"
      v-if="!cardSubmitStyle"
    ></div>
    <div
      class="submit-container"
      :class="{ isLogin: isLogin }"
      :style="cardSubmitStyle"
    >
      <div class="cart-container shadow" @click="showCartListHandle">
        <div class="cart-info">
          <div class="cart-info-icon">
            <Icon class="cart-info-icon-main" name="cart" />
            <em class="cart-info-icon-dot flex-center">
              {{ cartTotalQuantity }}
            </em>
          </div>
          <div class="cart-info-null" v-if="cartTotalQuantity <= 0">
            {{ letter.v3NoProduct }}
          </div>
          <div class="cart-info-had" v-else>
            <p class="cart-sum">
              {{ letter.v3Total }}
            </p>
            <div class="cart-info-cart j-click-open-cart">
              {{ realPrice }} {{ currency }}
              <Icon
                class="cart-info-ico"
                :class="{ active: showCartList }"
                name="down"
              ></Icon>
            </div>
          </div>
        </div>
        <div class="cart-icon flex-center" @click.stop="cartSubmit">
          <p class="cart-text">{{ letter.submit }}</p>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="showCartList"
        class="cart-list-mark"
        @click="setShowCartList(false)"
      ></div>
    </transition>
    <transition :name="isLandscape ? 'slide-up-cart' : 'slide-up'">
      <cart-list
        v-if="showCartList"
        :cardSubmitStyle="cardSubmitStyle"
        v-on:closeSelecter="setShowCartList(false)"
      ></cart-list>
    </transition>
  </div>
</template>

<script>
import CartList from '@components/officialTopupNew/cart/CartList.vue';
import {
  UPDATE_HAS_SELECT_PRODUCT,
  SET_HAS_LOAD_PAYTYPE
} from '@store/officialTopupNew';
import { UPDATE_SHOW_CARTLIST_STATUS } from '@store/officialTopupNew/cart';

import { mapState, mapGetters } from 'vuex';
import { times } from '@utiles/officialStore';

import coupon from '@mixins/officialTopupNew/coupon';
import pay from '@mixins/officialTopupNew/pay';
import zipcode from '@mixins/officialTopupNew/zipcode';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import { isIOS, isIpad } from '@utiles/device';

export default {
  name: 'cartSubmitFooter',
  mixins: [coupon, pay, zipcode, cartAddAndDetail],
  props: ['submitLoading', 'boolShowMoreProduct'],
  data() {
    return {
      currency: '',
      lookDetailItem: {},
      cardSubmitStyle: '',
      footerEle: null,
      showCartShadow: true
    };
  },
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape,
      letter: state => state.letter,
      hasLoadPaytype: state => state.hasLoadPaytype,
      coin_name: state => state.coin_name,
      paytype: state => state.paytype,
      lang: state => state.lang,
      showCartList: state => state.cart.showCartList,
      cartList: state => state.cart.cartList,
      isUidLogin: state => state.login.isUidLogin,
      isLogin: state => state.login.isLogin
    }),
    ...mapGetters([
      'cartTotalPrice',
      'cartTotalExtraCoin',
      'cartTotalQuantity',
      'cartDiscountTransMount',
      'getPointPayChannelName',
      'extraCoinName',
      'isCart'
    ]),
    reductionName() {
      return (
        '-' +
        this.activeCouponInfo.REDUCTION_MONEY +
        this?.paytype?.show_currency
      );
    },
    discountName() {
      return times(this.activeCouponInfo.DISCOUNT, 100) + '%OFF';
    },
    submitOrderBtnText() {
      if (
        this?.paytype &&
        this?.paytype?.f_pay_type === this.getPointPayChannelName &&
        this.isUidLogin
      ) {
        return this.letter.uidLoginName;
      } else {
        return this.letter.submitOrder;
      }
    }
  },
  watch: {
    cartList: {
      deep: true,
      handler(newVal) {
        if (newVal.length === 0) {
          this.setShowCartList(false);
          this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
          this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
        }
      }
    },
    paytype: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal?.show_currency) {
          this.currency = newVal?.show_currency;
        }
      }
    },
    boolShowMoreProduct: {
      handler() {
        this.handleScroll();
      }
    }
  },
  mounted() {
    if (this.isLandscape) {
      if (process.env.NODE_ENV === 'development') {
        window.addEventListener('scroll', this.handleScroll);
      } else {
        document.body.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  beforeDestroy() {
    if (this.isLandscape) {
      if (process.env.NODE_ENV === 'development') {
        window.removeEventListener('scroll', this.handleScroll);
      } else {
        document.body.removeEventListener('scroll', this.handleScroll);
      }
    }
  },
  methods: {
    handleScroll() {
      if (!this.isLandscape) {
        this.cardSubmitStyle = '';
        return;
      }
      if (!this.footerEle) {
        this.footerEle = document.querySelector('.footer');
      }
      // 判断元素是否在视口内
      const rect = this.footerEle.getBoundingClientRect();
      const dis = this.isLogin ? 10 : 40;
      let viewportHeight = window.innerHeight;

      // 检测是否为Safari浏览器
      const isSafari = isIOS() && !isIpad();

      let finalRect = rect;
      const zoom = window.getComputedStyle(document.body).zoom;

      if (isSafari) {
        finalRect = {
          top: rect.top * zoom,
          bottom: rect.bottom * zoom,
          height: rect.height * zoom
        };
        viewportHeight = viewportHeight / zoom;
      }

      if (finalRect.top - dis <= viewportHeight) {
        const translateY =
          finalRect.height - (finalRect.bottom - viewportHeight) + dis;
        this.cardSubmitStyle = `transform: translate3d(165px, -${
          translateY / zoom
        }px, 0);`;
      } else {
        this.cardSubmitStyle = ``;
      }
    },
    cartSubmit() {
      if (this.isLogin) {
        this.loadCartPayTypeListData();
      } else {
        this.$emit('showLoginPopup');
      }
    },
    setShowCartList(status) {
      if (this.isLogin) {
        this.$store.commit(UPDATE_SHOW_CARTLIST_STATUS, status);
      } else {
        this.$emit('showLoginPopup');
      }
    },
    lookCartList() {
      this.setShowCartList(true);
      this.sendCheckCartData();
    },
    showCartListHandle() {
      if (this.isLogin) {
        if (this.showCartList) {
          this.setShowCartList(false);
        } else {
          this.setShowCartList(true);
          this.sendCheckCartData();
        }
      } else {
        this.$emit('showLoginPopup');
      }
    }
  },
  components: {
    CartList
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';

//滑上
.slide-up-cart-enter-active,
.slide-up-cart-leave-active {
  will-change: transform;
  transition: all 0.3s ease-in-out;
}
.slide-up-cart-enter,
.slide-up-cart-leave-to {
  transform: translate3d(165px, 100%, 0) !important;
}

.submit-container-wrap {
  z-index: 21;
  position: relative;
}

.submit-container {
  overflow: hidden;
  z-index: 21;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 280px;
  width: 670px;
  margin: auto;
  border-radius: 10px;

  &.isLogin {
    bottom: 40px;
  }
}

.submit-shadow {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 230px;
  width: 100%;
  height: 200px;
  margin: auto;
  background: linear-gradient(
    to top,
    var(--backgroundColor) 0,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;

  &.isLogin {
    bottom: 0 !important;
  }
}

.cart-container {
  z-index: 1;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100px;
  cursor: pointer;

  .cart-info {
    flex: 1;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 50px;
    height: 100%;
    padding: 0 20px;
    background-color: #393535;
    border-radius: 10px 0 0 10px;

    &-icon {
      flex-shrink: 0;
      position: relative;
      &-main {
        width: 56px;
        height: 56px;
        color: #ffffff;
      }
      &-dot {
        position: absolute;
        top: -14px;
        right: -30px;
        width: 34px;
        height: 34px;
        background: linear-gradient(
          348deg,
          $buttonGradientColor1,
          $buttonGradientColor2
        );
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        border-radius: 50%;
      }
    }

    &-null {
      flex: 1;
      font-size: 22px;
      line-height: 1.5;
      text-align: left;
      color: #ffffff;
    }

    &-had {
      color: #ffffff;
      cursor: pointer;

      .cart-sum {
        font-size: 24px;
      }

      .cart-info-cart {
        position: relative;
        margin-top: 10px;
        font-size: 30px;
        font-weight: bold;

        .cart-info-ico {
          position: absolute;
          top: -4px;
          right: -50px;
          width: 34px;
          height: 34px;
          color: #ffffff;

          &.active {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  .cart-icon {
    flex-shrink: 0;
    position: relative;
    left: 0;
    top: 0;
    width: 216px;
    height: 100%;
    background-color: $themeColor;
    border-radius: 0 10px 10px 0;
    background: linear-gradient(
      348deg,
      $buttonGradientColor1,
      $buttonGradientColor2
    );
    .cart-text {
      font-size: 30px;
      font-weight: bold;
      color: #ffffff;
    }
  }
}

.cart-list-mark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

#ssr-page.landscape {
  .submit-container {
    overflow: visible;
    width: 614px;
    bottom: 40px;
    transform: translateX(165px);
  }
  .submit-shadow {
    bottom: 0;

    &.isLogin {
      bottom: 0;
    }
  }
  .cart-container {
    height: 80px;

    .cart-info {
      &-icon {
        &-dot {
          top: -8px;
          right: -26px;
          width: 28px;
          height: 28px;
          font-size: 16px;
        }
      }

      &-null {
        font-size: 16px;
      }

      &-had {
        .cart-sum {
          font-size: 16px;
        }

        .cart-info-cart {
          margin-top: 6px;
          font-size: 26px;
        }
      }
    }

    .cart-icon {
      width: 166px;
      .cart-text {
        font-size: 22px;
      }
    }
  }
}
</style>
